import { useCallback, useState } from 'react';
import { useKeyboard } from './useKeyboard';
const getInitialValue = (controls) => {
    const activeControl = controls.find((control) => control.active);
    if (activeControl) {
        return activeControl.value;
    }
    const firstEnabledControl = controls.find((control) => !control.disabled);
    if (firstEnabledControl) {
        return firstEnabledControl.value;
    }
    return '';
};
export const useSegmentedControl = ({ controls = [], direction = 'horizontal', onChange: onChangeProp, }) => {
    const [activeValue, setActiveValue] = useState(getInitialValue(controls));
    const [focusedValue, setFocusedValue] = useState(getInitialValue(controls));
    const onPress = useCallback((control) => {
        if (control.disabled) {
            return;
        }
        setActiveValue(control.value);
        setFocusedValue(control.value);
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(control);
    }, [onChangeProp]);
    const isActive = useCallback((control) => control.value === activeValue, [activeValue]);
    const isFocused = useCallback((control) => control.value === focusedValue, [focusedValue]);
    const { onKeyDown, setRef } = useKeyboard({
        controls,
        direction,
        onPress,
        onFocus: (control) => setFocusedValue(control.value),
    });
    return {
        activeValue,
        focusedValue,
        onPress,
        onKeyDown,
        isActive,
        isFocused,
        setRef,
    };
};
//# sourceMappingURL=useSegmentedControl.js.map